var validator = new function() {
    this.methods = function() {
        jQuery.validator.addMethod("phone", function(value, element) {
            var slug = /^[0-9\-]+$/;
            return slug.test(value) && value.length == 9;
        }, Laravel.lang.validation.phone);
    };
};

$(document).ready(function() {
    validator.methods();

    $("[data-search-form] input").bind("keyup",function(){
      var value = $(this).val();

      if(value.length>2){
        var currentRequest = null;

        currentRequest = jQuery.ajax({
            type: 'POST',
            data: {
              'phrase':value,
              '_token': window.Laravel.csrfToken,
              'lang': $('html').attr('lang')
            },
            url: '/module/search/hint',
            beforeSend : function()    {
                if(currentRequest != null) {
                    currentRequest.abort();
                }
            },
            success: function(data) {
                $("[data-search-form] ul").html('');
                if(Object.keys(data.results).length>0){
                  for (var prop in data.results) {
                    // for(var item in data.results[prop]){
                      var template = $("#search-hint-template").html();
                      var stone = Handlebars.compile(template)({"results":data.results[prop]});
                      var items = $.parseHTML(stone);
                      $("[data-search-hintcontainer]").append("<li><h2>"+Laravel.lang.search[prop]+"</h2></li>");
                      $("[data-search-hintcontainer]").append(items);
                    // }
                    $("[data-search-hintcontainer]").addClass('visible');
                  }
                }else{
                  $("[data-search-hintcontainer]").removeClass('visible')
                }
            },
            error:function(e){
              // Error
            }
        });
      }else{
        // $("[data-search-hintcontainer]").addClass('visible');
      }
    });
});

var newsletter = new function() {

    var me = this;

    this.bindEvents = function() {
        $("[data-form-newslettersubscribe]").bind("submit", function() {
            var form = $(this);
            var params = {
              'email': form.find("input[type='email']").val(),
              'lang': $('html').attr('lang'),
              '_token': window.Laravel.csrfToken
            };
            if($(this).valid()){
              $.post("/module/newsletter/subscribe",params, function(response) {
                  if(parseInt(response.code) == 1)
                    form.find("input[type='email']").val('');
                  $("[data-form-newslettermsg]").html(response.msg);
              },"json");
            }
            return false;
        });
    };
}

$(document).ready(function() {
    newsletter.bindEvents();
});

$(document).ready(function () {
    $('.js-gallery').each(function(){
        $(this).magnificPopup({
            delegate: 'a',
            type: 'image',
            tLoading: 'Ładowanie #%curr%...',
            mainClass: 'mfp-with-zoom',
            tClose: 'Zamknij',
            removalDelay: 400,
            gallery: {
                enabled: true,
                navigateByImgClick: true,
                tPrev: 'Poprzednie',
                tNext: 'Następne',
                preload: [0, 1], // Will preload 0 - before current, and 1 after the current image
                tCounter: '<span class="mfp-counter">%curr% z %total%</span>'
            },
            image: {
                tError: '<a href="%url%">Zdjęcie #%curr%</a> nie może być załadowane.',
                titleSrc: function (item) {
                    return item.el.attr('title');
                }
            },
            fixedContentPos: false
        });
    });
});
$(document).ready(function(){
    var elements = $("[data-galleryvideo]");
    for(var i=0; i<elements.length;i++){
      $(elements[i]).slick({
          dots: false,
          vertical: true,
          slidesToShow: 4,
          slidesToScroll: 1,
          verticalSwiping: true,
          infinite: false
      });
    }
    
    $('.js-videoSlider').each(function(){
        if ( $(this).find('.slick-slide').length > 3 ) {
        } else {
            $(this).closest('.videoSlider').addClass('short');
        }
    });


    $("[data-videourl]").on("click", function () {
        var el = $(this);
        var url = el.data("videourl");
        var instance = el.closest('.videoSlider__right').parent();
        instance.find('[data-target]').attr("src", url);
        instance.find('.videoSlide .slick-slide').removeClass('slick-current');
        el.closest('.slick-slide').addClass('slick-current');
    });
    
    $("[data-videourl]").eq(0).trigger("click");
});
$(document).ready(function(){
    $(".contentBlock").find("table").wrap("<div class='styledTable'></div>");
});
$(document).ready(function(){
    var popupLink = $(".hiddenPopup");
    if(popupLink.length == 1){
      var type = popupLink.data("type");

      if(type!=null){
        type = type.replace(/\s*$/,"");

        if(type === "inline") {
            popupLink.magnificPopup({
                mainClass: 'mfp-with-zoom',
                removalDelay: 400,
                items: {
                    src: '#popup',
                    type: type
                }
            });
        } else{
            popupLink.magnificPopup({
                type: 'iframe',
                mainClass: 'mfp-with-zoom',
                removalDelay: 400,
                iframe: {
                    markup: '<div class="mfp-iframe-scaler">' +
                    '<div class="mfp-close"></div>' +
                    '<iframe id="player" class="mfp-iframe" frameborder="0" allowfullscreen></iframe>' +
                    '</div>',
                    patterns: {
                        youtube: {
                            index: 'youtube.com/',
                            id: 'v=',
                            src: 'h%id%&autoplay=1'
                        }
                    }
                }
            });
        }
      }
    }
});

$(window).load(function () {
    $(".hiddenPopup").trigger("click");
});

$(document).ready(function(){
  var startBlog = Date.now();

  $("[data-comment-reply]").bind("click",function(){
    var index = $("[data-comment-row]").index($(this).closest("[data-comment-row]"));
    $("[data-comment-form]").insertAfter($("[data-comment-row]").eq(index));
    $("[data-comment-cancel]").show();
    $("[data-comment-form]").find("input[name='replay_to']").val($(this).closest("[data-comment-row]").attr("data-comment-row"));
  });

  $("[data-comment-cancel]").bind("click",function(){
    $("[data-comment-form]").insertAfter($("[data-comment-row]:last"));
    $("[data-comment-cancel]").hide();
    $("[data-comment-form]").find("input[name='replay_to']").val("");
  });

  $("[data-comment-form]").submit(function(){
    var submitBlog = Date.now();
    if($(this).valid() && (submitBlog-startBlog)/1000>6){
      return true;
    }else{
      return false;
    }
  });
});

var sonde = new function(){
  this.bindEvents = function(){
    $("[data-sonde-answer] button").bind("click",function(){
      var id = $(this).closest("[data-sonde-answer]").attr("data-sonde-answer");
      $.post('/module/sonde',{
          'id':id,
          '_token':$('[name="csrf-token"]').attr('content'),
          'lang': $('html').attr('lang')
        },function(response){
        $("[data-sonde-msg]").html(response.msg);
        $("[data-sonde-msg]").removeClass('hidden');
        $.each(response.results,function(index,value){
            $("[data-sonde-answer='"+index+"']").find('[data-sonde-value]').html(value);
            $("[data-sonde-answer='"+index+"']").find('[data-sonde-bar]').css({'width':value+'%'});
        });
      },"json");
    });
  };
};

$(document).ready(function(){
  if($("[data-sonde-container]").length==1)
    sonde.bindEvents();
});

// $(document).ready(function () {
//     var el = $('[data-cookies]');
//
//     $('[data-closecookies]').on('click', function () {
//         el.fadeOut();
//         Cookies.set('cookies_info', '1', {expires: 12});
//     });
//
//     var myCookie = Cookies.get('cookies_info');
//     if (myCookie === undefined) {
//         el.show();
//     }
// });

var category = new function() {
    var me = this;
    this.containerAmong;
    this.durningRequest = false;

    this.showNext = function(el) {
        var categoryBox = $(el).closest("[data-category-box]");
        var currentPage = parseInt(categoryBox.attr("data-category-currentpage"));
        var container = categoryBox.find("[data-category-container]");
        /*if (container.eq(currentPage).length > 0) {
            container.eq(currentPage).fadeIn();
        }
        if (container.eq(currentPage + 1).length == 0) {
            $(el).fadeOut();
        }
        $(el).closest("[data-category-box]").attr("data-category-currentpage", currentPage + 1);*/
        var data = {
            category_id: categoryBox.data("category-id"),
            page_nr: parseInt(categoryBox.data("category-page")) + 1,
            _token: Laravel.csrfToken,
            language: $('html').attr('lang')
        };

        if(typeof categoryBox.find("[data-category-thumbnail]")!=="undefined" && categoryBox.attr("data-category-thumbnail")!=""){
          data.thumbnail = categoryBox.attr("data-category-thumbnail");
        }

        if(typeof categoryBox.find("[data-module]")!=="undefind"){
          data.module = categoryBox.attr("data-module");
        }

        if(typeof categoryBox.find("[data-listing]")!=="undefind"){
          data.listing = categoryBox.attr("data-listing");
        }

        var requestParams = document.location.href.split('/').pop().split(',');
        if(requestParams.length > 1 && parseInt(requestParams[1])>=1 && parseInt(requestParams[1])<=12)
          data.month = requestParams[1];
        if(requestParams.length == 2)
          data.year = requestParams[1];
        else if(requestParams.length > 2)
          data.year = requestParams[2];

        if(!me.durningRequest)
          me.getPosts(data,categoryBox);
    };

    /**
     * data:
     *  category_id
     *  page_nr
     *  _token
     */
    this.getPosts = function(data,categoryBox){
      me.durningRequest = true;
      $.ajax({
          url: "/module/postfromcategory",
          method: "POST",
          data: data,
          dataType: "json",
          success: function (data) {
              if (data.posts.length == 0) {
                  $("[data-category-loadpage]").remove();
              } else {
                  var template = $("#entry-template").html();
                  var stone = Handlebars.compile(template)(data);
                  var $items = $.parseHTML(stone);
                  if(data.posts.length<parseInt(categoryBox.data('category-perpage')))
                    $("[data-category-loadpage]").remove();

                  categoryBox.find("[data-category-container]").append($items);
                  categoryBox.data('category-page', data.page);
                  $(".loader").data("offset", data.offset);
              }
              me.durningRequest = false;

              if(data.next==0)
                categoryBox.find('div[data-category-loadpage]').addClass('hidden');
          }
      });
    };

    this.bindEvents = function() {
        $("[data-category-loadpage]").bind("click", function() {
            me.showNext($(this));
        });
    };

};

$(document).ready(function () {
    category.bindEvents();

    $('.loader').on('inview', function (event, isInView) {
        if (isInView) {
            var data = {
                category_id: $("[data-category-id]").data("category-id"),
                page_nr: parseInt($("[data-category-page]").data("category-page")) + 1,
                _token: Laravel.csrfToken
            };

            category.getPosts(data);
        }
    });
});

Handlebars.registerHelper('dotdotdot', function(str,length) {
  if (str.length > length)
    return str.substring(0,length-1) + '...';
  return str;
});

Handlebars.registerHelper('compare', function (v1, operator, v2, options) {
   'use strict';
   console.log(options);
   var operators = {
     '==': v1 == v2 ? true : false,
     '===': v1 === v2 ? true : false,
     '!=': v1 != v2 ? true : false,
     '!==': v1 !== v2 ? true : false,
     '>': v1 > v2 ? true : false,
     '>=': v1 >= v2 ? true : false,
     '<': v1 < v2 ? true : false,
     '<=': v1 <= v2 ? true : false,
     '||': v1 || v2 ? true : false,
     '&&': v1 && v2 ? true : false
   }
   if (operators.hasOwnProperty(operator)) {
     if (operators[operator]) {
       return options.fn(this);
     }
     return options.inverse(this);
   }
   return console.error('Error: Expression "' + operator + '" not found');
});

Handlebars.registerHelper('indexof', function(array,index) {
  if(array.length > index)
    return array[index];
  else
    return "";
});

$(document).ready(function () {
  $('.js-openMenu').on("click", function () {
    $(this).toggleClass('active');
    $('.mobileMenu').toggleClass('opened');
    $('body').addClass('noscroll');
  });

  $('.js-close').on("click", function () {
    $('.mobileMenu').removeClass('opened');
    $('body').removeClass('noscroll');
  });

  $('body').on("click", '.js-prev', function () {

    var el = $(this);
    $(".mobileMenu ul.opened").removeClass("opened");
    $("[data-menu].actived").removeClass("actived");
    $(".js-prev").remove();
  });

  $('.mobileMenu li').each(function() {
    if ( $(this).find('ul').length ) {
      $(this).addClass('withSubmenu');
      $(this).find('a').append('<span class="mobileMenu__submenuSwitcher"></span>');
      $(this).find('a').addClass('subMenuLink');

    }
  });


  function submenuSwitcher() {
    $("[data-menu].subMenuLink").on("click", function (e) {
          $(this).toggleClass("actived")
          e.preventDefault();
          var el = $(this).parent();
          el.toggleClass("actived");
          $('.withSubmenu.actived ul').toggleClass("opened")
    });
  }
  submenuSwitcher();

  $('.js-searchBox .searchBox__icon').on('click', function() {
    $(this).parent().toggleClass('active');
    $('.js-searchBox input').focus();
    $('.mobileMenu__language').toggleClass('hide');
  });

});

/*! modernizr 3.6.0 (Custom Build) | MIT *
 * https://modernizr.com/download/?-webp-setclasses !*/
 !function(e,n,A){function o(e,n){return typeof e===n}function t(){var e,n,A,t,a,i,l;for(var f in r)if(r.hasOwnProperty(f)){if(e=[],n=r[f],n.name&&(e.push(n.name.toLowerCase()),n.options&&n.options.aliases&&n.options.aliases.length))for(A=0;A<n.options.aliases.length;A++)e.push(n.options.aliases[A].toLowerCase());for(t=o(n.fn,"function")?n.fn():n.fn,a=0;a<e.length;a++)i=e[a],l=i.split("."),1===l.length?Modernizr[l[0]]=t:(!Modernizr[l[0]]||Modernizr[l[0]]instanceof Boolean||(Modernizr[l[0]]=new Boolean(Modernizr[l[0]])),Modernizr[l[0]][l[1]]=t),s.push((t?"":"no-")+l.join("-"))}}function a(e){var n=u.className,A=Modernizr._config.classPrefix||"";if(c&&(n=n.baseVal),Modernizr._config.enableJSClass){var o=new RegExp("(^|\\s)"+A+"no-js(\\s|$)");n=n.replace(o,"$1"+A+"js$2")}Modernizr._config.enableClasses&&(n+=" "+A+e.join(" "+A),c?u.className.baseVal=n:u.className=n)}function i(e,n){if("object"==typeof e)for(var A in e)f(e,A)&&i(A,e[A]);else{e=e.toLowerCase();var o=e.split("."),t=Modernizr[o[0]];if(2==o.length&&(t=t[o[1]]),"undefined"!=typeof t)return Modernizr;n="function"==typeof n?n():n,1==o.length?Modernizr[o[0]]=n:(!Modernizr[o[0]]||Modernizr[o[0]]instanceof Boolean||(Modernizr[o[0]]=new Boolean(Modernizr[o[0]])),Modernizr[o[0]][o[1]]=n),a([(n&&0!=n?"":"no-")+o.join("-")]),Modernizr._trigger(e,n)}return Modernizr}var s=[],r=[],l={_version:"3.6.0",_config:{classPrefix:"",enableClasses:!0,enableJSClass:!0,usePrefixes:!0},_q:[],on:function(e,n){var A=this;setTimeout(function(){n(A[e])},0)},addTest:function(e,n,A){r.push({name:e,fn:n,options:A})},addAsyncTest:function(e){r.push({name:null,fn:e})}},Modernizr=function(){};Modernizr.prototype=l,Modernizr=new Modernizr;var f,u=n.documentElement,c="svg"===u.nodeName.toLowerCase();!function(){var e={}.hasOwnProperty;f=o(e,"undefined")||o(e.call,"undefined")?function(e,n){return n in e&&o(e.constructor.prototype[n],"undefined")}:function(n,A){return e.call(n,A)}}(),l._l={},l.on=function(e,n){this._l[e]||(this._l[e]=[]),this._l[e].push(n),Modernizr.hasOwnProperty(e)&&setTimeout(function(){Modernizr._trigger(e,Modernizr[e])},0)},l._trigger=function(e,n){if(this._l[e]){var A=this._l[e];setTimeout(function(){var e,o;for(e=0;e<A.length;e++)(o=A[e])(n)},0),delete this._l[e]}},Modernizr._q.push(function(){l.addTest=i}),Modernizr.addAsyncTest(function(){function e(e,n,A){function o(n){var o=n&&"load"===n.type?1==t.width:!1,a="webp"===e;i(e,a&&o?new Boolean(o):o),A&&A(n)}var t=new Image;t.onerror=o,t.onload=o,t.src=n}var n=[{uri:"data:image/webp;base64,UklGRiQAAABXRUJQVlA4IBgAAAAwAQCdASoBAAEAAwA0JaQAA3AA/vuUAAA=",name:"webp"},{uri:"data:image/webp;base64,UklGRkoAAABXRUJQVlA4WAoAAAAQAAAAAAAAAAAAQUxQSAwAAAABBxAR/Q9ERP8DAABWUDggGAAAADABAJ0BKgEAAQADADQlpAADcAD++/1QAA==",name:"webp.alpha"},{uri:"data:image/webp;base64,UklGRlIAAABXRUJQVlA4WAoAAAASAAAAAAAAAAAAQU5JTQYAAAD/////AABBTk1GJgAAAAAAAAAAAAAAAAAAAGQAAABWUDhMDQAAAC8AAAAQBxAREYiI/gcA",name:"webp.animation"},{uri:"data:image/webp;base64,UklGRh4AAABXRUJQVlA4TBEAAAAvAAAAAAfQ//73v/+BiOh/AAA=",name:"webp.lossless"}],A=n.shift();e(A.name,A.uri,function(A){if(A&&"load"===A.type)for(var o=0;o<n.length;o++)e(n[o].name,n[o].uri)})}),t(),a(s),delete l.addTest,delete l.addAsyncTest;for(var p=0;p<Modernizr._q.length;p++)Modernizr._q[p]();e.Modernizr=Modernizr}(window,document);
// main slider
$('.js-slider').on('init reInit afterChange', function() {
    $('.slick-slide:not(.slick-current)').removeClass('slider__item--visible');
    $('.js-slider .slick-current').addClass('slider__item--visible');
});
$('.js-slider').slick({
    arrows: true,
    speed: 700,
    fade: true,
    autoplaySpeed: 7000,
    dots: true,
    infinite: true,
    autoplay: true,
    lazyLoad: 'ondemand'
});
//slider--3 dots
if ( $('.js-slider--3').length ) {
    $('.js-slider--3 .slick-dots button').each(function(i) {
        i++;
        n=i;
        $(this).attr('data-number',++i).append('<span>0'+ n +'</span>');
    });
}
//realization__slider
$('.js-realization__image').slick({
    arrows: false,
    speed: 700,
    fade: true,
    autoplaySpeed: 7000,
    dots: false,
    infinite: true,
    autoplay: true,
    asNavFor: '.js-realization__gallery',
    responsive: [
  {
    breakpoint: 1024,
    settings: {
      arrows: true
    }
  },
  ]
});
$('.js-realization__gallery').slick({
    arrows: true,
    speed: 700,
    autoplaySpeed: 7000,
    dots: false,
    infinite: true,
    autoplay: true,
    vertical: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    verticalSwiping: true,
    asNavFor: '.js-realization__image',
    verticalSwiping:true,
    focusOnSelect: true
});

$(document).ready(function(){


  $('body').on('click', '.password-control1', function(){
	if ($('#password').attr('type') == 'password'){
		$(this).addClass('view');
		$('#password').attr('type', 'text');
	} else {
		$(this).removeClass('view');
		$('#password').attr('type', 'password');
	}
	return false;
});


$('body').on('click', '.password-control2', function(){
if ($('#password2').attr('type') == 'password'){
  $(this).addClass('view');
  $('#password2').attr('type', 'text');
} else {
  $(this).removeClass('view');
  $('#password2').attr('type', 'password');
}
return false;
});


$('body').on('click', '.password-control3', function(){
if ($('#password_confirmation').attr('type') == 'password'){
  $(this).addClass('view');
  $('#password_confirmation').attr('type', 'text');
} else {
  $(this).removeClass('view');
  $('#password_confirmation').attr('type', 'password');
}
return false;
});


$('body').on('click', '.password-control2', function(){
if ($('#password_confirmation2').attr('type') == 'password'){
  $(this).addClass('view');
  $('#password_confirmation2').attr('type', 'text');
} else {
  $(this).removeClass('view');
  $('#password_confirmation2').attr('type', 'password');
}
return false;
});
$('body').on('click', '.password-control3', function(){
if ($('#password_confirmation3').attr('type') == 'password'){
  $(this).addClass('view');
  $('#password_confirmation3').attr('type', 'text');
} else {
  $(this).removeClass('view');
  $('#password_confirmation3').attr('type', 'password');
}
return false;
});



  $(".product__show").click(function(){
    $("#showImage").fadeIn();
    $('#showImage').css('display','flex');
  });
  $(".closeBtn").click(function(){
    $("#showImage").fadeOut();
  });
  $(document).click(function(event) {
    if (!$(event.target).closest(".product__show").length) {
      $("#showImage").fadeOut();
    }
  });

  $('.filters__buttonMobile').on("click", function () {
    $('.filters').slideToggle();
    $(this).toggleClass('active');
  });

  $(".representatives__flagsItem").click(function() {
      if($(".multicontact--filter").length>0){
        $([document.documentElement, document.body]).animate({
            scrollTop: $(".multicontact--filter").offset().top - 100
        }, 2000);
      }else{
        $([document.documentElement, document.body]).animate({
            scrollTop: $("[data-multicontacts]").offset().top - 100
        }, 2000);
      }
  });


  // imageslider
  $('.js-sliderGallery').slick({
      arrows: true,
      speed: 700,
      autoplaySpeed: 7000,
      dots: true,
      infinite: true,
      autoplay: false,
      slidesPerRow: 5,
      rows: 2,
      responsive: [
        {
          breakpoint: 678,
          settings: {
            slidesPerRow: 2,
            rows: 2
          }
        }
      ]
  });



  //if Sidebar exists
  if ( $('.main__sidebar').length ) {
    $('.offerBoxes').addClass('offerBoxes--withSidebar');
  }

  // go to form message
  if ( $('.formErrors__item').length ) {
    $('html, body').animate({
        scrollTop:  $('.formErrors__item').first().offset().top - 200
    }, 600);
  }
  // go to form map
  if ( $('.button--localization').length ) {
    $('.button--localization').on('click', function(){
      $('html, body').animate({
          scrollTop:  $('iframe').first().offset().top - 200
      }, 600);
      return false;
    });

  }



  //js-tabs

  if ( $('.js-tabs').length ) {

    let showItems = function() {
      let activeTab = $('.js-tabs a.active').attr('data-tab');
      $('.product__imagesGallery').hide();
      $('.product__imagesGallery[data-tab="'+activeTab+'"]').show();
    }
    showItems();
    $('.js-tabs a:not("active")').on('click', function(){
      $(this).addClass('active').siblings().removeClass('active');
      showItems();
      return false;
    })
  }

  //file input
  if ( $('.filters__item--file').length ) {
      var fileInput  = document.querySelector( ".filters__item--file input" ),
      button     = document.querySelector( ".filters__item--file" ),
      the_return = document.querySelector(".filters__item--file span");

      button.addEventListener( "keydown", function( event ) {
          if ( event.keyCode == 13 || event.keyCode == 32 ) {
              fileInput.focus();
          }
      });
      button.addEventListener( "click", function( event ) {
        fileInput.focus();
        return false;
      });
      fileInput.addEventListener( "change", function( event ) {
          the_return.innerHTML = this.value;
      });
  }

  //image map
  if ($('.js-svgMap').length) {
    $('.land').on('click', function(){
      var country;
      $('.land.active').attr("class", "land");
      $(this).attr("class", "land active");
      $('.representatives__flagsItem').removeClass('active');
      country = $(this).attr('data-country');
      var countryFlag = $('.representatives__flagsItem[data-country="'+ country +'"]');
      countryFlag.addClass('active');

      if(typeof countryFlag.attr('data-href')!=="undefined")
        top.location.href = countryFlag.attr('data-href');
      else
        showContact(country);

        $('html, body').animate({
          scrollTop: $("[data-multicontacts]").first().offset().top - 70
        }, 1000);
    });
    $('.representatives__flagsItem').on('click', function(){
      var country;
      $('.land.active').attr("class", "land");
      $('.representatives__flagsItem').removeClass('active');
      country = $(this).attr('data-country');
      $(this).addClass('active');
      $('.land[data-country="'+country+'"]').attr("class", "land active");

      if(typeof $(this).attr('data-href')!=="undefined")
        top.location.href = $(this).attr('data-href');
      else
        showContact(country);
    });

    function showContact(country) {
      $('[data-multicontacts] [data-multicontact]').each(function(){
        if ( typeof $(this).attr('data-filter')!=="undefined" && ($(this).attr('data-filter').indexOf(country)===0 || $(this).attr('data-filter').indexOf(' '+country)!==-1)) {
          $(this).show();
        } else {
          $(this).hide();
        }
      });

      $('.multicontact--filter .multicontact__itemRow').each(function(){
        if ( typeof $(this).attr('data-filter')!=="undefined"  && ($(this).attr('data-filter').indexOf(country)===0 || $(this).attr('data-filter').indexOf(' '+country)!==-1)) {
          $(this).show();
        } else {
          $(this).hide();
        }
      });
    }



  }

  $("[data-filter-submit]").click(function(){
    var filters = $("[data-filter]"),name,value,counter=1,type;
    var url = top.location.href.split(",");
    var checkedFilters = new Array();
    url = url[0]+",1&";
    for(var i=0;i<filters.length;i++){
      name = filters.eq(i).attr('data-filter');
      type = filters.eq(i).attr('type');

      if($.inArray(name,checkedFilters)===-1){
        value = "";
        if($("[data-filter='"+name+"']").length>1){
          var subFilters = $("[data-filter='"+name+"']");
          for(var j=0;j<subFilters.length;j++){
            if(type=="checkbox"){
              value+= subFilters.eq(j).is(":checked") ? filters.eq(j).val()+"," : "";
            }else{
              value+= subFilters.eq(j).val()+",";
            }
          }
          if(value[value.length-1] == ","){
            value = value.slice(0,-1);
          }
        }else if(type=="checkbox"){
          value = filters.eq(i).is(":checked") ? filters.eq(i).val() : "";
        }else{
          value = filters.eq(i).val();
          if(value===null)
            value = "";
        }

        if(typeof value!=="undefined" && value!=""){
          if(typeof filters.eq(i).attr('data-filter-name')==="undefined"){
            url+= "filter_" + counter + "=" + name + "&value_" + counter + "=" + value+"&";
            counter++;
          }else{
            url+= filters.eq(i).attr('data-filter-name') + "=" + value+"&";
          }
        }

        checkedFilters.push(name);
      }
    }
    if(url[url.length-1] == "&"){
      url = url.slice(0,-1);
    }

    top.location.href = url;
  });

  $("[data-filter-clear]").click(function(){
    var url = top.location.href.split(",");
    top.location.href = url[0];
  });

  var sms = {
    id: "",
    number: "",
    lang: "",
    type: "",
    openPoup: function(id){
      this.id = id;
      this.lang = $("html").attr('lang');
      $(".download__popupFirst").show();
      $(".download__popupLast").hide();
      $("[data-download-smsmsg]").html("");
      $("input[name='download_code']").val("");
      var translation = window.Laravel.lang.download;
      $("[data-download-smsheader]").html(translation["sms_"+sms.type+"_header"]);
      $("[data-download-validatesms]").html(translation[sms.type]);
      $.magnificPopup.open({
        items: {
          src: '#download_popup'
        },
        type: 'inline',
        closeOnBgClick: false
      });
    },
    closePopup: function(){
      $.magnificPopup.close();
    },
    sendSms: function(number){
      this.number = number;
      if(!isNaN(number) && parseInt(number)>=100000000){
        $(".download__popupFirst").hide();
        $.post('/module/download/sendsms',{'id':this.id,'number':number,'_token':window.Laravel.csrfToken,'lang':$('html').attr('lang')},function(response){
          if(parseInt(response.code)==1){
            $(".download__popupLast").show();
            $("[data-download-smsmsg]").html(window.Laravel.lang.download.sms_send_success);
          }else{
            $(".download__popupFirst").show();
            $(".download__popupLast").hide();
            $("[data-download-smsmsg]").html(window.Laravel.lang.download.sms_send_failure);
          }
        });
      }
    },
    validateSms: function(code){
      if(code!=""){
        $.post('/module/download/validatesms',{'id':sms.id,'code':code,'number':sms.number,'type':sms.type,'_token':window.Laravel.csrfToken},function(response){
          if(response.code ==1){
            $.ajax({
              url: response.msg,
              statusCode: {
                200: function(){
                  if(sms.type=="download"){
                    $("[data-download-sms='"+sms.id+"'][data-download-smsdownload]").attr('href',response.msg);
                    top.location.href = response.msg;
                  }else{
                    $("[data-download-sms='"+sms.id+"'][data-download-smsopen]").addClass('_PDFF_link openbut').attr('source',response.msg).trigger('click');
                  }
                  sms.closePopup();
                },
                403: function() {
                  $("[data-download-smsmsg]").html(window.Laravel.lang.download.sms_validate_failure);
                },
                404: function() {
                  $("[data-download-smsmsg]").html(window.Laravel.lang.download.file_no_exists);
                },
                500: function() {
                  $("[data-download-smsmsg]").html(window.Laravel.lang.download.sms_validate_error);
                }
              }
            });
          }else{

          }
        });
      }
    },
    bindEvents: function(){
      $("[data-download-sms]").bind("click",function(){
        sms.type = typeof $(this).attr("data-download-smsopen") !== "undefined" ? "open" : "download";
        if(
            (typeof $(this).attr("data-download-smsopen") !== "undefined" && typeof $(this).attr("source")==="undefined")
            ||
            (typeof $(this).attr("href")==="undefined")
        )
          sms.openPoup($(this).attr('data-download-sms'));
      });
      $("[data-download-sendsms]").bind("click",function(){ sms.sendSms($("input[name='download_phone']").val()); });
      $("[data-download-validatesms]").bind("click",function(){ sms.validateSms($("input[name='download_code']").val()); });
    }
  };
  sms.bindEvents();

  $("[data-filter='title']").on('keypress',function(e) {
    if(e.which == 13) {
        $("[data-filter-submit]").trigger('click');
    }
  });

  $("[data-architect]").bind("click",function(){
    if($(".module .catalogs").length>0){
      $('html, body').animate({
        scrollTop: $(".module .catalogs").eq(0).closest(".module").offset().top - $("ul.menu").eq(0).height() - 10
      }, 1000);
    }
    return false;
  });

  $('.filters--realizations select').addClass('has-placeholder');

  var originalHeight = $('.product .product__description .contentBlock').height();
  if($(".product .product__description .contentBlock").height() < $(window).width()*0.322) {
    $('.product .button.button--product').css('display', 'none');
  }
  else {
    $(".product__description .contentBlock").css('height','32.292vw');
    $('.product .button.button--product').css('display', 'flex');
  }
  $('.button--product').click(function(){
    if ($(this).hasClass('show')){
      $(".product .product__description .contentBlock").addClass('more').animate({height: originalHeight},1000);
      // $(this).text('Zwiń');
      $(this).removeClass('show');
    }
    else {
      $(".product .product__description .contentBlock").removeClass('more').animate({height: '32.292vw'},1000);
      // $(this).text('Rozwiń');
      $(this).addClass('show');
    }
  });

  $("select[data-filter=realization_system]").bind('change',function(){
    var parentId = $(this).find('option:selected').val();
    $("select[data-filter=realization_subsystem]").val('');
    $("select[data-filter=realization_subsystem] option").not(':first').css('display','none');
    $("select[data-filter=realization_subsystem]").find("option[data-parent-id="+parentId+"]").css('display','block');
  });
  var subSystemSelected = $("select[data-filter=realization_subsystem]").find('option:selected').val();
  $("select[data-filter=realization_system]").trigger('change');
  if(subSystemSelected!=""){
    $("select[data-filter=realization_subsystem]").val(subSystemSelected);
  }

  if($("[data-training-user]").length){
    $("[data-training-add-user]").bind('click',function(){
      var limit = parseInt($(".countUsers").html());
      if($("[data-training-user]").length==limit){
        alert(window.Laravel.lang.training.limit);
      }else{
        var html = $("[data-training-user]")[0].outerHTML;
        $("[data-training-user]:last").after(html);
        $("[data-training-user]:last").find('input').val('');
      }
    });
    $(document).on('click', '[data-training-remove-user]', function() {
      if($("[data-training-user]").length==1){
        alert(window.Laravel.lang.training.insert_one);
      }else{
        $(this).closest('[data-training-user]').remove();
      }
    });
  }
}); // end document ready

$(window).on('load', function(){

});


$('.filters--realizations select').on('change', function(){
  $(this).removeClass('has-placeholder');
});

$(document).ready(function(){


  $('.account').on("click", function () {
    $('.accountWrap').slideToggle();
  });


    $('.searchMobileIcon').on("click", function () {
      $('.searchMobileWrap').slideToggle();
    });





  //language - select

  $('.languageBox__select').on('click', function() {
      $('.languageBox__list').toggleClass('visible');
      return false;
  });

  //aos
  if ( $('[data-aos]').length ) {
      AOS.init({
          offset: 50,
          duration: 500
      });
      // var delay = 0;
      // $('.contact--boxes > div').each(function() {
      //     delay = delay + 150;
      //     $(this).attr('data-aos-delay', delay);
      // });
  }

  // lazyload
  const observer = lozad(); // lazy loads elements with default selector as '.lozad'
  observer.observe();

  // scrolled menu
if ($(window).width()<1240){
          $('.js-header').addClass('header--scrolled');
  } else {
      $('.js-header').removeClass('header--scrolled');
  }

  // relax init
  if ($('.rellax').length) {
      var rellax = new Rellax('.rellax', {
        wrapper: '.rellax-parent',
        relativeToWrapper: true,
      });
  }

  // js-up
  $(".js-up").on("click", function () {
      var body = $("html, body");
      body.stop().animate({scrollTop: 0}, 1500, 'swing');
  });

  //go to form
  $('.js-gotoform').on('click', function(){
      var anchor = $('.footer__form');
      if (anchor.length) {
          $('html, body').animate({
              scrollTop:  $(anchor).offset().top
          }, 600);
          return false;
      }

  });


  // scrolled menu
  if ($(window).scrollTop() > 0) {
    $('.js-header').addClass('header--scrolled');
    if ($('.hamburger--2').length) {
      $('.hamburger--2').on("click", function () {
        //$(this).toggleClass('active');
        $('.header--3').removeClass('header--scrolled');
      });
    }
  } else {
    if ( $(window).width()>1240 && $('.hamburger--2').length==0 ){
      $('.js-header').removeClass('header--scrolled');
    }
  }

  //search
  $('.js-header__search').on('click', function(){
      $('.header .header__searchBox form').toggleClass('header__searchBoxForm--hidden');
      $('.header .header__searchBox').slideToggle(300);
  });
  $('.js-header__searchBoxIcon').on('click', function(){
    $('[data-search-form]').submit();
  });


  //video button
  if ( $('.popup-youtube').length ) {
      $('.popup-youtube').magnificPopup({
        disableOn: 700,
        type: 'iframe',
        mainClass: 'mfp-fade',
        removalDelay: 160,
        preloader: false,

        fixedContentPos: false
    });
  }


}); // end document ready


$(window).on("scroll", function () {

// js-up
var scroll = $(window).scrollTop();
if (scroll > 600) {
    $(".js-up").addClass("visible");
} else {
    $(".js-up").removeClass("visible");
}

// scrolled menu
if ($(window).scrollTop() > 0){
  $('.js-header').addClass('header--scrolled');
 } else {
  if ($(window).width()>1240){
    $('.js-header').removeClass('header--scrolled');
  }
}

}); // end onscroll

//# sourceMappingURL=subpage.js.map
